import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

export const getRestaurantCustomers = createAsyncThunk(
  "Ststistics/getRestaurantCustomers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/statistics/customers`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRestaurantRatings = createAsyncThunk(
  "Ststistics/getRestaurantRatings",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/statistics/ratings`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRestaurantOrders = createAsyncThunk(
  "Ststistics/getRestaurantOrders",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/statistics/orders`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRevenue = createAsyncThunk(
  "Ststistics/getRevenue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/statistics/revenue`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getLogs = createAsyncThunk(
  "Ststistics/getLogs",
  async (page, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/log-activities`,
          {
            headers: getHeaders(true),
            params: {
              page: page || 1,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const StstisticsSlice = createSlice({
  name: "Ststistics",
  initialState: {
    isStstisticsLoading: false,
    error: null,
    ResturantCustomersArr: null,
    RevenueArray: null,
    RestaurantRatingsArray: null,
    RestaurantOrdersArray: null,
    LogsArray: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // getRestaurantOrders
      .addCase(getRestaurantOrders.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRestaurantOrders.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.RestaurantOrdersArray = action.payload.data;
      })
      .addCase(getRestaurantOrders.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      })
      .addCase(getRevenue.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRevenue.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.RevenueArray = action.payload.data;
      })
      .addCase(getRevenue.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      })
      .addCase(getRestaurantRatings.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRestaurantRatings.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.RestaurantRatingsArray = action.payload.data;
      })
      .addCase(getRestaurantRatings.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      })
      .addCase(getRestaurantCustomers.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRestaurantCustomers.fulfilled, (state, action) => {
        state.ResturantCustomersArr = action.payload.data;
        state.isStstisticsLoading = false;
      })
      .addCase(getRestaurantCustomers.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload; // يمكن إضافة هذا السطر لتخزين الخطأ
      })

      .addCase(getLogs.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getLogs.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.LogsArray = action.payload;
      })
      .addCase(getLogs.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      });
  },
});

export default StstisticsSlice.reducer;
